<sw-page class="riccardo-offer-detail">
    <template #smart-bar-header>
        <h2>{{ offer?.name || $t('riccardo-offer.detail.titleNew') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button :router-link="{ name: 'riccardo.offer.list' }">{{ $t('global.default.cancel') }}</sw-button>
        <sw-button-process variant="primary" :is-loading="isLoading" :process-success="isSaveSuccessful" @click="onSave">
            {{ $t('global.default.save') }}
        </sw-button-process>
    </template>

    <template #content>
        <sw-card-view v-if="offer">
            <sw-card :title="$t('riccardo-offer.detail.cardGeneral')" :is-loading="isLoading">
                <sw-switch-field v-model:value="offer.active" :label="$t('riccardo-offer.detail.active')" />
                <sw-text-field v-model:value="offer.name" :label="$t('riccardo-offer.detail.name')" :help-text="$t('riccardo-offer.detail.nameHelp')" required />
                <sw-container columns="2fr 1fr" gap="0 24px">
                    <sw-text-field v-model:value="offer.headline" :label="$t('riccardo-offer.detail.headline')" required />
                    <sw-text-field v-model:value="offer.badge" :label="$t('riccardo-offer.detail.badge')" :help-text="$t('riccardo-offer.detail.badgeHelp')" />
                </sw-container>
                <sw-textarea-field v-model:value="offer.description" :label="$t('riccardo-offer.detail.description')" />
                <sw-text-field v-model:value="offer.linkPath" :label="$t('riccardo-offer.detail.linkPath')" :help-text="$t('riccardo-offer.detail.linkPathHelp')" />
            </sw-card>

            <sw-card :title="$t('riccardo-offer.detail.cardDiscount')" :is-loading="isLoading">
                <sw-entity-single-select
                    v-model:value="offer.promotionId"
                    entity="promotion"
                    :criteria="promotionCriteria"
                    label-property="name"
                    :label="$t('riccardo-offer.detail.promotion')"
                    :help-text="$t('riccardo-offer.detail.promotionHelp')"
                    @update:value="onPromotionChange"
                />
                <sw-text-field v-model:value="offer.code" :label="$t('riccardo-offer.detail.code')" :help-text="$t('riccardo-offer.detail.codeHelp')" />
            </sw-card>

            <sw-card :title="$t('riccardo-offer.detail.cardAudience')" :is-loading="isLoading">
                <sw-single-select v-model:value="offer.audience" :options="audienceOptions" :label="$t('riccardo-offer.detail.audience')" />

                <sw-entity-multi-select
                    v-if="offer.audience === 'customers'"
                    v-model:entity-collection="offer.customers"
                    label-property="email"
                    :label="$t('riccardo-offer.detail.customers')"
                    :help-text="$t('riccardo-offer.detail.customersHelp')"
                />

                <sw-entity-single-select
                    v-if="offer.audience === 'group'"
                    v-model:value="offer.customerGroupId"
                    entity="customer_group"
                    label-property="translated.name"
                    :label="$t('riccardo-offer.detail.customerGroup')"
                />

                <sw-entity-single-select
                    v-if="offer.audience === 'tag'"
                    v-model:value="offer.tagId"
                    entity="tag"
                    label-property="name"
                    :label="$t('riccardo-offer.detail.tag')"
                />
            </sw-card>

            <sw-card :title="$t('riccardo-offer.detail.cardValidity')" :is-loading="isLoading">
                <sw-container columns="1fr 1fr" gap="0 24px">
                    <sw-number-field v-model:value="offer.durationHours" number-type="int" :min="0" :label="$t('riccardo-offer.detail.durationHours')" :help-text="$t('riccardo-offer.detail.durationHoursHelp')" />
                    <sw-number-field v-model:value="offer.priority" number-type="int" :label="$t('riccardo-offer.detail.priority')" :help-text="$t('riccardo-offer.detail.priorityHelp')" />
                </sw-container>
                <sw-container columns="1fr 1fr" gap="0 24px">
                    <sw-datepicker v-model:value="offer.startsAt" date-type="datetime" :label="$t('riccardo-offer.detail.startsAt')" />
                    <sw-datepicker v-model:value="offer.endsAt" date-type="datetime" :label="$t('riccardo-offer.detail.endsAt')" />
                </sw-container>
                <sw-alert variant="info">{{ summary }}</sw-alert>
            </sw-card>
        </sw-card-view>
    </template>
</sw-page>
